module.exports = __webpack_public_path__ + "images/newerp_button3.1791972770245.png";